export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
/**
 * @param choice number
 * @param choicesLength number
 * http://www.unicode.org/cldr/charts/latest/supplemental/language_plural_rules.html#pl
 */
export function pluralizationRules(choice, choicesLength) {
	let result = 3; //many
	if (choice === 0) {
		return 0; //Special case zero
	}

	const teen = (choice % 100) > 10 && (choice % 100) < 20;
	const digit = choice % 10;

	if (digit === 1) {
		result = 1; //one
	}

	if (!teen && digit >= 2 && digit <= 4) {
		result = 2; //few
	}

	return Math.min(result, choicesLength - 1);
};

export const messages = {
    "login.form.title": "Zaloguj się",
    "login.form.hint.user": "Nazwa logowania",
    "login.form.hint.password": "Hasło",
    "login.form.checkbox.remember-me": "Zapamiętaj mnie",
    "login.form.button.sign-in": "Zaloguj się",
    "login.form.message.invalid-user-credentials": "Nazwa logowania lub hasło są niepoprawne",
    "login.form.message.account-temporarily-locked": "Konto zostało tymczasowo zablokowane. Spróbuj ponownie za 5 minut.",
    "login.form.message.user-required": "Wprowadź nazwę logowania",
    "login.form.message.password-required": "Wprowadź hasło",
    "login.form.button.forgot-password": "Nie pamiętasz hasła?",
    "error.mfa-required.title": "Skonfiguruj 2FA",
    "error.mfa-required.message1": "Uwierzytelnianie dwuskładnikowe (2FA) jest wymagane, aby chronić Twoje konto.",
    "error.mfa-required.message2": "Zostaniesz przekierowany do ustawień swojego konta w Pulpicie nawigacyjnym Online. Włącz 2FA, postępuj zgodnie z instrukcjami konfiguracji, a następnie wróć tutaj.",
    "error.mfa-required.learnMore": "Dowiedz się więcej o 2FA",
    "error.mfa-required.continue": "Kontynuuj",
    "error.root-admin-login.title": "Błąd 403 — dostęp wzbroniony",
    "error.root-admin-login.message": "Zalogowano się jako administrator Tylko do odczytu. Aby uzyskać dostęp do konsoli Web Recovery, zaloguj się jako dzierżawca-klient lub administrator",
    "error.server-busy.message": "Serwer zajęty. Spróbuj ponownie później.",
    "error.network-connection.title": "Błąd połączenia sieciowego",
    "error.network-connection.message": "Sprawdź połączenie z Internetem i spróbuj ponownie.",
    "error.internal-server-error.title": "Wewnętrzny błąd serwera",
    "error.internal-server-error.message": "Aby naprawić ten błąd, skontaktuj się z zespołem pomocy technicznej, podając szczegółowe informacje o błędzie:",
    "error.internal-server-error.copy.button": "Kopiuj"
};
